module.exports = __webpack_public_path__ + "img/yourthoughts-locked.6c32d3b2.svg";